export default {
  primary: "#525EF6", //royalblue/purple
  tertiary: "#23374d", //lightblue
  accent: "#fd0575", //pink
  accent2: "#3fbad4", // teal
}
